import { handleActions } from 'redux-actions';
import * as actions from './actions';

const defaultState = {
  isSigning: false,
  signError: null
};

const authByFacebookReducer = handleActions(
  {
    [actions.facebookSignInRequest]: (state, action) => ({ ...state, isSigning: true }),
    [actions.facebookSignInSuccess]: (state, action) => ({ ...state, isSigning: false, signError: null }),
    [actions.facebookSignInFailed]: (state, action) => ({ ...state, isSigning: false, signError: action.payload }),

    [actions.resetFacebookErrors]: (state, action) => ({ ...state, signError: null }),
  },
  defaultState
);

export default authByFacebookReducer;